var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#ffc250}"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    style: {
      fill: "#fb4d43"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m11.68 5.79-6.4 4.57a.54.54 0 0 0-.18.42v6.89a.53.53 0 0 0 .51.54h12.78a.53.53 0 0 0 .51-.54v-6.89a.54.54 0 0 0-.18-.42l-6.4-4.57a.49.49 0 0 0-.64 0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m18.86 10.56-6.1 3.95a1.4 1.4 0 0 1-1.52 0l-6.1-3.95a.54.54 0 0 0 0 .22v6.89a.53.53 0 0 0 .51.54h12.74a.53.53 0 0 0 .51-.54v-6.89a.54.54 0 0 0 0-.22z",
    style: {
      fill: "#ffe07d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.86 10.56 17 11.76v4.9a.53.53 0 0 1-.51.54H5.1v.47a.53.53 0 0 0 .51.54h12.78a.53.53 0 0 0 .51-.54v-6.89a.54.54 0 0 0 0-.22z",
    style: {
      fill: "#ffd064"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.24 14.51a1.4 1.4 0 0 0 1.52 0l4.94-3.2V9a1.17 1.17 0 0 0-.34-.83l-2.08-2.03a1.16 1.16 0 0 0-.82-.35h-7A1.17 1.17 0 0 0 6.3 7v4.35z",
    style: {
      fill: "#eaf2ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.36 8.21-1.55-1.54v5.86l1.88-1.22V9a1.17 1.17 0 0 0-.33-.79z",
    style: {
      fill: "#dbe8f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.36 8.21-2.08-2.07a1.16 1.16 0 0 0-.34-.24v2.22a.54.54 0 0 0 .54.53h2.16a1.37 1.37 0 0 0-.28-.44z",
    style: {
      fill: "#e07f84"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.61 18.21h12.78a.5.5 0 0 0 .41-.21l-5.32-3.92-.7.45a1.4 1.4 0 0 1-1.52 0l-.71-.46L5.22 18a.49.49 0 0 0 .39.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17 16.67a.52.52 0 0 1-.51.53H6.3l-1.08.8a.49.49 0 0 0 .39.2h12.78a.5.5 0 0 0 .41-.2z",
    style: {
      fill: "#ebb044"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.86 10.2-.94-.82V9a1.39 1.39 0 0 0-.41-1l-2.07-2a1.39 1.39 0 0 0-1-.4h-7A1.38 1.38 0 0 0 6.08 7v1a.22.22 0 0 0 .44 0V7a1 1 0 0 1 .94-1h7a.75.75 0 0 1 .26 0v2.12a.76.76 0 0 0 .76.75h2a1 1 0 0 1 0 .17v2.15l-4.84 3.14a1.17 1.17 0 0 1-1.28 0l-4.84-3.14V9a.22.22 0 0 0-.44 0v.36l-.94.82a.77.77 0 0 0-.26.58v6.89a.74.74 0 0 0 .73.75h12.78a.74.74 0 0 0 .73-.75v-6.87a.77.77 0 0 0-.26-.58zm-3.38-1.76a.32.32 0 0 1-.32-.32v-1.8l2.05 2 .06.07zM17.92 10l.63.55-.63.41zM5.31 17.67v-6.74l4.84 3.14zm.77-6.76-.63-.41.63-.5zM5.61 18l4.93-3.67.58.38a1.65 1.65 0 0 0 1.76 0l.57-.38 1.63 1.2a.22.22 0 1 0 .25-.35l-1.49-1.1 4.85-3.14v6.71l-2.54-1.87a.22.22 0 1 0-.25.35L18.42 18H5.61z",
    style: {
      fill: "#2d3e5c"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.c0fe1c6507c88997faf1d5638eebaa91.svg";
export { ForwardRef as ReactComponent };